const VirtualEvents = () => {
  return (
    <div className="h-[40vh] flex items-center justify-center">
      <p className="text-lg sm:text-base md:text-lg lg:text-xl xl:text-2xl font-bold text-gray-400">
        {" "}
        Coming Soon
      </p>
    </div>
  );
};
export default VirtualEvents;
